import { getStageTypeLabel } from 'modules/championship/domain/constants/stage-type-labels';
import { i18n } from 'shared/i18n/i18n';

/**
 * Подпись типа этапа для публичной страницы турнира. Через глобальный `i18n`: язык читается
 * в момент вызова. Неизвестный тип печатается как есть.
 */
const getRoundTypeLabel = (type: string) => {
  const label = getStageTypeLabel(type);
  return label ? i18n._(label) : type;
};
export default getRoundTypeLabel;
